// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.foreignResidency__primaryAddress h3,
.foreignResidency__foreignAddress h3 {
  margin-bottom: 0;
}
.foreignResidency__primaryAddress .icon-delete,
.foreignResidency__foreignAddress .icon-delete {
  margin-left: 10px;
  display: inline-block;
  vertical-align: top;
}
.immediateMember__heading {
  margin-bottom: 10px;
}
.foreignResidency__usAccountInfo .usAccountInfo__heading {
  margin-bottom: 10px;
}
.immediateMember .layout-4,
.foreignResidency__usAccountInfo .layout-4 {
  width: calc(25% - 20px);
}
.immediateMember__delete,
.usAccountInfo__delete {
  display: flex;
  -webkit-display: flex;
  align-items: center;
}
.foreignResidency__rowLable {
  font-size: 14px;
  display: inline-block;
  color: #000;
  line-height: 1.6;
}
.foreignResidency__header {
  display: flex;
  -webkit-display: flex;
  margin-bottom: 15px;
}
.foreignResidency__headerLabel {
  font-size: 14px;
  width: 22%;
  color: #000;
  line-height: 1.6;
  font-weight: 600;
}
.foreignResidency__headerLabel.locationLabel {
  width: 26%;
}
.foreignResidency__headerLabel.emptyLabel {
  width: 30%;
}
.foreignResidency__fields,
.foreignResidency__rowFields {
  display: flex;
  -webkit-display: flex;
}
.foreignResidency__rowFields > .label-value-wrapper:first-child {
  width: 40%;
}
.foreignResidency__rowFields > .label-value-wrapper {
  width: 15%;
}
.foreignResidency__rowFields > .label-value-wrapper input {
  padding: 0 10px;
}
.foreignResidency__rowLable {
  width: 30%;
}
.foreignResidency__rowFields {
  width: 70%;
}
.financialBackground__headerLabel {
  font-size: 14px;
  width: 17.5%;
  color: #000;
  line-height: 1.6;
  font-weight: 600;
}
.financialBackground__header > .financialBackground__headerLabel {
  width: 23%;
}
.financialBackground__header > .financialBackground__headerLabel:first-child {
  width: 30%;
}
.financialBackground__rowLable {
  font-size: 14px;
  display: inline-block;
  color: #000;
  line-height: 1.6;
  width: 30%;
}
.financialBackground__header,
.financialBackground__fields {
  display: flex;
  -webkit-display: flex;
}
.financialBackground__header {
  margin-bottom: 15px;
}
.financialBackground__rowFields {
  display: flex;
  -webkit-display: flex;
  width: 70%;
}
.financialTotalAssetValue {
  display: flex;
  -webkit-display: flex;
}
.financialTotalAssetValue .financialBackground__rowFields {
  justify-content: right;
}
.financialTotalAssetValue .financialBackground__rowFields .label-value-wrapper {
  width: 30%;
}
.financialTotalAssetValue input:disabled {
  background: rgba(239, 239, 239, 0.3);
}
`, "",{"version":3,"sources":["webpack://./src/components/pages/foreignResidencyAndFinancial/ForeignResidencyAndFinancial.css"],"names":[],"mappings":"AAAA;;EAEE,gBAAgB;AAClB;AACA;;EAEE,iBAAiB;EACjB,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,uBAAuB;AACzB;AACA;;EAEE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,qBAAqB;EACrB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;;EAEE,aAAa;EACb,qBAAqB;AACvB;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,eAAe;AACjB;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,eAAe;EACf,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,UAAU;AACZ;AACA;;EAEE,aAAa;EACb,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,UAAU;AACZ;AACA;EACE,aAAa;EACb,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,UAAU;AACZ;AACA;EACE,oCAAoC;AACtC","sourcesContent":[".foreignResidency__primaryAddress h3,\n.foreignResidency__foreignAddress h3 {\n  margin-bottom: 0;\n}\n.foreignResidency__primaryAddress .icon-delete,\n.foreignResidency__foreignAddress .icon-delete {\n  margin-left: 10px;\n  display: inline-block;\n  vertical-align: top;\n}\n.immediateMember__heading {\n  margin-bottom: 10px;\n}\n.foreignResidency__usAccountInfo .usAccountInfo__heading {\n  margin-bottom: 10px;\n}\n.immediateMember .layout-4,\n.foreignResidency__usAccountInfo .layout-4 {\n  width: calc(25% - 20px);\n}\n.immediateMember__delete,\n.usAccountInfo__delete {\n  display: flex;\n  -webkit-display: flex;\n  align-items: center;\n}\n.foreignResidency__rowLable {\n  font-size: 14px;\n  display: inline-block;\n  color: #000;\n  line-height: 1.6;\n}\n.foreignResidency__header {\n  display: flex;\n  -webkit-display: flex;\n  margin-bottom: 15px;\n}\n.foreignResidency__headerLabel {\n  font-size: 14px;\n  width: 22%;\n  color: #000;\n  line-height: 1.6;\n  font-weight: 600;\n}\n.foreignResidency__headerLabel.locationLabel {\n  width: 26%;\n}\n.foreignResidency__headerLabel.emptyLabel {\n  width: 30%;\n}\n.foreignResidency__fields,\n.foreignResidency__rowFields {\n  display: flex;\n  -webkit-display: flex;\n}\n.foreignResidency__rowFields > .label-value-wrapper:first-child {\n  width: 40%;\n}\n.foreignResidency__rowFields > .label-value-wrapper {\n  width: 15%;\n}\n.foreignResidency__rowFields > .label-value-wrapper input {\n  padding: 0 10px;\n}\n.foreignResidency__rowLable {\n  width: 30%;\n}\n.foreignResidency__rowFields {\n  width: 70%;\n}\n.financialBackground__headerLabel {\n  font-size: 14px;\n  width: 17.5%;\n  color: #000;\n  line-height: 1.6;\n  font-weight: 600;\n}\n.financialBackground__header > .financialBackground__headerLabel {\n  width: 23%;\n}\n.financialBackground__header > .financialBackground__headerLabel:first-child {\n  width: 30%;\n}\n.financialBackground__rowLable {\n  font-size: 14px;\n  display: inline-block;\n  color: #000;\n  line-height: 1.6;\n  width: 30%;\n}\n.financialBackground__header,\n.financialBackground__fields {\n  display: flex;\n  -webkit-display: flex;\n}\n.financialBackground__header {\n  margin-bottom: 15px;\n}\n.financialBackground__rowFields {\n  display: flex;\n  -webkit-display: flex;\n  width: 70%;\n}\n.financialTotalAssetValue {\n  display: flex;\n  -webkit-display: flex;\n}\n.financialTotalAssetValue .financialBackground__rowFields {\n  justify-content: right;\n}\n.financialTotalAssetValue .financialBackground__rowFields .label-value-wrapper {\n  width: 30%;\n}\n.financialTotalAssetValue input:disabled {\n  background: rgba(239, 239, 239, 0.3);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
